import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ_ITEMS: FAQItem[] = [
  {
    question: 'Qui est Upnov IA ?',
    answer: 'Upnov IA est un organisme français de formation à l\'intelligence artificielle pour les entreprises, fondé en 2019 et basé à Coeur Défense, Courbevoie. Nous concevons des formations intra-entreprise sur mesure, des ateliers de cas d\'usage métier et des séminaires d\'acculturation pour les PME, ETI et grands comptes.',
  },
  {
    question: 'Quels formats de formation IA propose Upnov IA ?',
    answer: 'Du webinaire de sensibilisation de 2 heures au parcours de transformation de 5 jours, en passant par la journée d\'acculturation, l\'atelier métier et le team building IA. Les groupes comptent en général 10 à 15 participants pour les ateliers pratiques, et jusqu\'à plusieurs centaines de personnes en format séminaire.',
  },
  {
    question: 'Les formations Upnov IA sont-elles finançables par l\'OPCO ?',
    answer: 'Oui. Elles sont dispensées dans le cadre d\'un partenariat avec un organisme certifié Qualiopi, qui émet la convention de formation et le dossier de prise en charge. Le dossier se dépose auprès de votre OPCO avant le démarrage, dans le cadre du plan de développement des compétences.',
  },
  {
    question: 'Où Upnov IA intervient-il ?',
    answer: 'Directement dans vos locaux partout en France, Suisse et Belgique. Les formats distanciels sont également disponibles pour les équipes réparties sur plusieurs sites.',
  },
  {
    question: 'Quelles entreprises Upnov IA a-t-il formées ?',
    answer: 'Plus de 1 300 professionnels dans plus de 200 entreprises depuis 2019, dont EDF, RATP, Orano, L\'Oréal, Thales, Vinci, Eiffage, la Caisse des Dépôts, La Poste, Safran, SNCF et Carrefour, ainsi que de nombreuses PME et ETI franciliennes.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="mt-12">
      <h3 className="heading-md text-center mb-8">Questions fréquentes</h3>
      <div className="space-y-3">
        {FAQ_ITEMS.map((item, index) => (
          <div key={index} className="border border-gray-200 rounded-xl overflow-hidden">
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-start justify-between p-5 md:p-6 hover:bg-gray-50 transition-colors text-left"
              aria-expanded={openIndex === index}
            >
              <span className="font-semibold text-gray-900 pr-4">{item.question}</span>
              <ChevronDown
                size={20}
                className={`text-primary shrink-0 mt-0.5 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            {openIndex === index && (
              <div className="px-5 md:px-6 pb-5 md:pb-6 bg-gray-50 border-t border-gray-200">
                <p className="text-gray-600 leading-relaxed">{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
